webpackJsonp([35],{

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {document.addEventListener('DOMContentLoaded', function () {
  var formItemQuantity = $('#item-quantity-form');
  var formShipping = $('#shipping-form');
  var shippingSelector = $('#checkout-shipping-address');

  $('.checkout-shipping-address__change-cep').click(function () {
    var changeCep = $('.checkout-shipping-address__choose-method');
    var changeAddress = $('.checkout-shipping-address__consult-cep');

    changeCep.click(function () {
      $(this).addClass('hidden');

      changeAddress.fadeIn('slow', function () {
        changeAddress.removeClass('hidden');
      });
    });
  });

  shippingSelector.change(function () {
    formShipping.submit();
  });

  $('input.quantity-change').change(function (event) {
    if (!event.target.checkValidity()) {
      var input = event.target;
      var max = parseInt(event.target.max, 10);
      var quantityMessage = document.querySelector('.quantity-message');

      quantityMessage.innerHTML = 'O estoque possui apenas ' + max + ' ' + (max === 1 ? 'item' : 'itens');
      input.value = max;

      setTimeout(function () {
        quantityMessage.innerHTML = '';
        formItemQuantity.submit();
      }, 5000);
      return;
    }

    formItemQuantity.submit();
  });

  $('.checkout-form__quantity').each(function () {
    var spinner = $(this);
    var input = spinner.find('input[type="number"]');
    var btnUp = spinner.find('.quantity-up');
    var btnDown = spinner.find('.quantity-down');
    var min = input.attr('min');
    var max = input.attr('max');

    btnUp.click(function () {
      var oldValue = parseFloat(input.val());
      var newVal = void 0;

      if (oldValue >= max) {
        newVal = oldValue;
      } else {
        newVal = oldValue + 1;
      }
      spinner.find('input').val(newVal);
      spinner.find('input').trigger('change');
    });

    btnDown.click(function () {
      var oldValue = parseFloat(input.val());
      var newVal = void 0;

      if (oldValue <= min) {
        newVal = oldValue;
      } else {
        newVal = oldValue - 1;
      }
      spinner.find('input').val(newVal);
      spinner.find('input').trigger('change');
    });
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })

},[55]);


// WEBPACK FOOTER //
// checkout/checkout-4df01491a4808c1cad00.js